<template>
    <Modal  v-model:visible="visible">
        <template #header>
            <h2 class="font-bold text-xl mb-4">
                <slot name="title">Apporvazione azienda</slot>
            </h2>
        </template>
        <template #main>
            <p class="mb-4"><slot name="content">Desideri approvare o rifiutare l'azienda?</slot></p>
            <p v-show="error" class="mb-4 text-next-orange">{{error}}</p>
        </template>
        <template #footer>
            <div class="flex justify-between flex-col md:flex-row pt-3">
                <NextButton variant="primary"
                    @click="$emit('approva')"
                    class="py-2 px-4 mb-3 md:mb-0">
                    Approva
                </NextButton>
                <NextButton variant="primary"
                    @click="$emit('rifiuta')"
                    class="py-2 px-4 mb-3 md:mb-0">
                    Rifiuta
                </NextButton>
                <NextButton variant="outline-secondary"
                    @click="$emit('update:visible', false)"
                    class="py-2 px-4">
                    Chiudi
                </NextButton>
            </div>
        </template>
    </Modal>

</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import Modal from "@/components/Modal.vue";
import NextButton from "@/components/NextButton.vue";


@Options({
    name:'ModalApprovaRifiuta',
    components: {
        NextButton,
        Modal
    },
    props: {
        visible: {
            type: Boolean,
            default: true
        },
        error: {
            type: String,
            default: null
        },
    }
})
export default class ModalApprovaRifiuta extends Vue {
    visible!: boolean
}
</script>


<style lang="scss">
</style>
